export const footer_links: Record<string, string> = {
  //text
  footer_top_title: 'footer-top-title',
  footer_column_1_title: 'footer-column-1-title',
  footer_column_2_title: 'footer-column-2-title',
  footer_column_3_title: 'footer-column-3-title',
  footer_column_4_title: 'footer-column-4-title',
  brokerCheckSVG: 'broker-check-svg',
  brokerCheckText: 'broker-check-text',
  //links
  footer_column_1_link_1: 'footer-column-1-link-1',
  footer_column_1_link_2: 'footer-column-1-link-2',
  footer_column_1_link_3: 'footer-column-1-link-3',
  footer_column_1_link_4: 'footer-column-1-link-4',
  footer_column_2_link_1: 'footer-column-2-link-1',
  footer_column_2_link_2: 'footer-column-2-link-2',
  footer_column_2_link_3: 'footer-column-2-link-3',
  footer_column_2_link_4: 'footer-column-2-link-4',
  footer_column_3_link_1: 'footer-column-3-link-1',
  footer_column_3_link_2: 'footer-column-3-link-2',
  footer_column_3_link_3: 'footer-column-3-link-3',
  footer_column_3_link_4: 'footer-column-3-link-4',
  footer_column_3_link_5: 'footer-column-3-link-5',

  footer_column_4_link_1: 'footer-column-4-link-1',
  footer_column_4_link_2: 'footer-column-4-link-2',
  footer_column_4_link_3: 'footer-column-4-link-3',
  footer_column_4_link_4: 'footer-column-4-link-4',
  footer_column_4_link_5: 'footer-column-4-link-5',

  footer_resource_link_1: 'footer-resource-link-1',
  footer_resource_link_2: 'footer-resource-link-2',
  footer_resource_link_3: 'footer-resource-link-3',
  footer_resource_link_4: 'footer-resource-link-4',
  footer_resource_link_5: 'footer-resource-link-5',
  footer_resource_link_6: 'footer-resource-link-6',
  footer_social_link_1: 'footer-social-link-1',
  footer_social_link_2: 'footer-social-link-2',
  footer_social_link_3: 'footer-social-link-3',
  footer_social_link_4: 'footer-social-link-4',
  footer_social_link_5: 'footer-social-link-5',
};
